module.exports = __webpack_public_path__ + "media/um_volto_ja.d72adf4b.mp3";